/**
 * Terms page — apenas setup i18n + lang picker. Sem compressor.
 */
import '@/styles/main.css';
import '@/styles/legal.css';
import { setupPageShell } from '@/ui/page-setup.js';

function init() {
  setupPageShell();
  console.info('compress: ready (terms)');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
